import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { ElevatedButton } from '@producer/ui-kit';

import { Card } from '../../components/on-boarding/Card';
import { WorkspaceList } from '../settings/components/workspace-list';
import { Member } from '../../app/entities';

export const ChooseWorkspacePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation() as { state: { spaceId?: string; referrer?: string } };

  const handleAcceptInvitation = async (member: Member) => {
    const href = `/space/${member.spaceId}`;
    navigate(href);
  };

  const handleCreateSpace = () => {
    navigate('/onboarding/create-workspace', { state: location.state });
  };

  return (
    <Card
      title="Accept invitations or create workspace"
      subtitle="You have pending invitations."
      footer={<ElevatedButton text="Create space" onClick={handleCreateSpace} isFullWidth />}
    >
      <WorkspaceList onAcceptInvitation={handleAcceptInvitation} />
    </Card>
  );
};
